
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectionNoCaution as ObiConnectionNoCautionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-no-caution.js';
 
 
 

 
 export const ObiConnectionNoCaution = createComponent({
   react: React,
   tagName: 'obi-connection-no-caution',
   elementClass: ObiConnectionNoCautionElement,
   events: {
     
   }
  });
 
 